import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, updateData, getcountries } from '../../../services/admin/abstractReceipt/abReviewersServices';
import { Modal, Button, Table } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Swal from 'sweetalert2';
import Spinner from '../../../components/Spinner';


const PendingReviewers = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '',
    reviewer_name : '',
    reviewer_affiliation : '',
    reviewer_country : '',
    sub_domain : '',
    series: '',
    reviewer_signature : '',
    status : 0,
    approval: 0,
    });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [dropdownData, setDropdownData] = useState({
      countries: [],
  }); 
  
  const fetchData = useCallback(async () => {
    try {
      const data = await getData({ approval: 0 });
      setDataList(data);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

   // Fetch all dropdown data
  const fetchDropdownData = useCallback(async () => {
    try {
      const [country] = await Promise.all([
        getcountries(),            
      ]);
  
      setDropdownData({
        countries: country,
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }, []);
  

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      await fetchDropdownData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData, fetchDropdownData]);

  const handleSubmit = async () => {
    try {
      if (modalType === 'edit') {
        const updatedForm = { ...form, status: 1, approval: 1 }; // Set status to 1
        await updateData(updatedForm);
      }
      fetchData();
      setShowModal(false);
    // ✅ Show success alert with auto-close
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: `Reviewer ${modalType === 'add' ? 'added' : 'Approved'} successfully!`,
            timer: 2000, // 2 seconds
            showConfirmButton: false,
          });
    
        } catch (error) {
          console.error('Error during form submission:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Something went wrong while submitting the form!',
          });
        }
  };

  const openModal = (type, data = { id: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  //based country code append country name
  const getCountryName = (code) => {
  const country = dropdownData.countries.find(c => c.code === code);
  return country ? country.name : code;
  };


  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter((data) => data.reviewer_name.toLowerCase().includes(searchText.toLowerCase()) ||
    data.sub_domain.toLowerCase().includes(searchText.toLowerCase())
  )
  .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
   {
         name: '#',
         selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
         sortable: false,
         width: '10%',
       },
       {
           name: 'SubDomain',
           selector: (row) => row.sub_domain,
           sortable: true,
           width: '10%',
           wrap: true
       },
          {
        name: 'Series',
        selector: (row) => {
          // Assuming the `series` field is in format like "2025-11" or "2025-11-15"
          const date = new Date(row.series);
          
          // Format as "2025-11 Nov 2025"
          const year = date.getFullYear();
          const month = date.getMonth(); // 0-based index, so we add 1
          const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
          
          return ` ${months[month]} ${year}`;
        },
        sortable: true,
        width: '10%',
        wrap: true
      },
       {
         name: 'Name',
         selector: (row) => row.reviewer_name,
         sortable: true,
          width: '15%',
          wrap: true

       },
       {
         name: 'Country',
         selector: (row) => getCountryName(row.reviewer_country || 'N/A'),
         sortable: true,
          width: '10%',
          wrap: true

       },
       {
        name: 'Signature',
        cell: (row) => (
          <a
            href={row.reviewer_signature}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={row.reviewer_signature}
              width="100"
              alt={row.reviewer_affiliation}
              style={{ borderRadius: "5px", cursor: "pointer" }}
            />
          </a>
        ),
        sortable: false,
        width: '15%',
        wrap: true
      },
      {
        name: 'Status',
        cell: (row) => (
          <span className={`badge ${Number(row.status) === 1 ? 'bg-success' : 'bg-danger'}`}>
            {Number(row.status) === 1 ? 'Active' : 'Inactive'}
          </span>
        ),
        sortable: true,
        width: '10%',
        wrap: true
      },
      {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)}>Edit</Button>
        </div>
      ),
      width: '15%',
      wrap: true
    },
  ];
  
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4 text-dark">PDF Generation / Abstract Receipt / Reviewer / Pending Reviewers</p>
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText} onChange={handleSearchChange} />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal className="modal-lg" backdrop="static" show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalType === 'add' ? 'Add ' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                     
                    </thead>
                    <tbody>
                    </tbody>
                    <br></br>
                    <thead>
                      <tr>
                        <th className='bg-secondary text-white' colSpan={2}>Reviewer Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Reviewer Name</td>
                        <td>{form.reviewer_name	}</td>
                      </tr>
                      <tr>
                        <td>Reviewer Affilation</td>
                        <td>{form.reviewer_affiliation}</td>
                      </tr>
                      <tr>
                        <td>Reviewer Country</td>
                        <td>{getCountryName(form.reviewer_country)}</td>
                      </tr>
                      <tr>
                        <td>Signature</td>
                        <td>
                            <img
                              src={form.reviewer_signature}
                              width="300"
                              alt="Reviewer Signature"
                            />
                        </td>
                      </tr>            
                    </tbody>
                    <br></br>
                  </Table>
             
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
              <Button variant="primary" onClick={handleSubmit}>{modalType === 'add' ? 'Add' : 'Approved'}</Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default PendingReviewers;
